import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

/**
 * Get student quiz data
 * @param {*} [queryParams={}] - query params to be passed to the request
 * @param {boolean} [skip=false] - Used to skip the query if required values are not present
 */
const useLazyStudentQuizGet = (queryParams = {}, skip = false) => {
  let resource = `${API_BASE_URL}/api/v3/studentquiz/`;
  const queryString = new URLSearchParams(queryParams).toString();

  resource = `${resource}?${queryString}`;
  return useLazyRestQuery(resource, { skip });
};

export default useLazyStudentQuizGet;
